import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormControlLabel, Grid, MenuItem, Switch, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { labOrderStatusConfig } from './labOrderStatus';

export default function LabOrderFilters({ screen }) {
  const {
    laboratories,
    professionals,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    laboratoryId,
    setLaboratoryId,
    dentistId,
    setDentistId,
    status,
    setStatus,
    onlyLate,
    setOnlyLate,
    clearFilters,
  } = screen;

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid size={{ xs: 6, md: 2 }}>
        <DatePicker
          label="Envio de"
          value={startDate}
          onChange={(date) => setStartDate(date)}
          format="DD/MM/YYYY"
          disabled={onlyLate}
          slotProps={{ textField: { fullWidth: true } }}
        />
      </Grid>
      <Grid size={{ xs: 6, md: 2 }}>
        <DatePicker
          label="Envio até"
          value={endDate}
          onChange={(date) => setEndDate(date)}
          format="DD/MM/YYYY"
          disabled={onlyLate}
          slotProps={{ textField: { fullWidth: true } }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 2 }}>
        <TextField
          select
          fullWidth
          label="Laboratório"
          value={laboratoryId}
          onChange={(event) => setLaboratoryId(event.target.value)}
        >
          <MenuItem value="">Todos</MenuItem>
          {laboratories.map((laboratory) => (
            <MenuItem key={laboratory.id} value={laboratory.id}>
              {laboratory.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 2 }}>
        <TextField
          select
          fullWidth
          label="Profissional"
          value={dentistId}
          onChange={(event) => setDentistId(event.target.value)}
        >
          <MenuItem value="">Todos</MenuItem>
          {professionals.map((professional) => (
            <MenuItem key={professional.id} value={professional.id}>
              {professional.nome}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 2 }}>
        <TextField
          select
          fullWidth
          label="Status"
          value={status}
          onChange={(event) => setStatus(event.target.value)}
        >
          <MenuItem value="">Todos</MenuItem>
          {Object.entries(labOrderStatusConfig).map(([key, config]) => (
            <MenuItem key={key} value={key}>
              {config.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={{ xs: 12, md: 2 }} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <FormControlLabel
          control={
            <Switch
              color="error"
              checked={onlyLate}
              onChange={(event) => setOnlyLate(event.target.checked)}
            />
          }
          label="Atrasados"
        />
        <Button size="small" onClick={clearFilters}>
          Limpar
        </Button>
      </Grid>
    </Grid>
  );
}

LabOrderFilters.propTypes = {
  screen: PropTypes.shape({
    laboratories: PropTypes.array.isRequired,
    professionals: PropTypes.array.isRequired,
    startDate: PropTypes.object,
    setStartDate: PropTypes.func.isRequired,
    endDate: PropTypes.object,
    setEndDate: PropTypes.func.isRequired,
    laboratoryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    setLaboratoryId: PropTypes.func.isRequired,
    dentistId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    setDentistId: PropTypes.func.isRequired,
    status: PropTypes.string,
    setStatus: PropTypes.func.isRequired,
    onlyLate: PropTypes.bool.isRequired,
    setOnlyLate: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
  }).isRequired,
};
